import { render, staticRenderFns } from "./CarrierAttachments.vue?vue&type=template&id=8ddbba86&"
import script from "./CarrierAttachments.vue?vue&type=script&lang=js&"
export * from "./CarrierAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports